import { createPortal } from "react-dom";
import { MessageCircle } from "lucide-react";

const ADMIN_WHATSAPP_NUMBER = "919414156086";
const DEFAULT_MESSAGE = encodeURIComponent(
  "Hello Oswal Sabha Professional Forum, I need help with membership, activities, or admin support.",
);

export default function FloatingWhatsApp() {
  const href = `https://wa.me/${ADMIN_WHATSAPP_NUMBER}?text=${DEFAULT_MESSAGE}`;

  const button = (
    <a
      href={href}
      target="_blank"
      rel="noreferrer"
      aria-label="Chat on WhatsApp"
      title="Chat on WhatsApp"
      className="fixed bottom-5 right-5 z-[9999] inline-flex items-center gap-2 rounded-full bg-[#25D366] px-4 py-3 text-white shadow-2xl shadow-black/20 transition hover:scale-105 hover:bg-[#1fb355] focus:outline-none focus:ring-2 focus:ring-[#25D366]/40"
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-semibold">WhatsApp</span>
    </a>
  );

  if (typeof document === "undefined") {
    return button;
  }

  return createPortal(button, document.body);
}
